<template>
  <main>
    <van-steps :active="active">
      <van-step>验证手机</van-step>
      <van-step>重置密码</van-step>
      <van-step>成功</van-step>
    </van-steps>
    <template v-if="active === 0">
      <van-cell-group>
        <van-field
          v-model="phone"
          type="tel"
          required
          clearable
          label="手机号"
          placeholder="请输入手机号"
          @blur="showImageCaptcha"
        />
        <van-field
          v-model="imageCaptcha"
          center
          required
          clearable
          label="图形验证码"
          placeholder="请输入图形验证码"
        />
        <img
          v-if="imageCaptchaShow"
          :src="imageCaptchaURL"
          alt=""
          class="image-captcha"
          @click="getImageCaptchaURL">
        <van-field
          v-model="captcha"
          center
          required
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
        >
          <van-button
            slot="button"
            :disabled="disabled"
            size="small"
            type="default"
            @click="handleSendSmsCode">{{ sendText }}</van-button>
        </van-field>
      </van-cell-group>
      <div class="p-3">
        <van-row class="pb-2">
          <van-col span="24">
            <van-button
              type="primary"
              size="large"
              @click="handleOnClickNext">下一步</van-button>
          </van-col>
        </van-row>
        <van-row class="pb-2">
          <van-col
            span="24"
            class="text-center">
            <router-link :to="{name: 'login'}">已有账号？立即登录</router-link>
          </van-col>
        </van-row>
      </div>
    </template>
    <template v-if="active === 1">
      <van-cell-group>
        <van-field
          v-model="password"
          type="password"
          label="密码"
          placeholder="请输入密码"
          required
        />
        <van-field
          v-model="repeatPassword"
          type="password"
          label="确认密码"
          placeholder="请确认密码"
          required
        />
      </van-cell-group>
      <div class="p-3">
        <van-row class="pb-2">
          <van-col span="24">
            <van-button
              type="primary"
              size="large"
              @click="handleOnSubmit">重置密码</van-button>
          </van-col>
        </van-row>
        <van-row class="pb-2">
          <van-col
            span="24"
            class="text-center">
            <router-link :to="{name: 'login'}">已有账号？立即登录</router-link>
          </van-col>
        </van-row>
      </div>
    </template>
    <template v-if="active === 2">
      <div class="p-5 text-center bg-white">
        <van-icon
          name="checked"
          class="icon text-success"/>
        <p>密码重置成功</p>
        <van-row class="pb-2">
          <van-col span="24">
            <van-button
              type="primary"
              size="large"
              @click="$router.push({name: 'login'})">返回登录</van-button>
          </van-col>
        </van-row>
      </div>
    </template>
  </main>
</template>

<script>
import JSEncrypt from 'jsencrypt';
import { apiURL, rsaPublicKey } from '@/libs/const';

export default {
  name: 'ResetPassword',
  data() {
    return {
      phone: '',
      password: '',
      repeatPassword: '',
      captcha: '',
      active: 0,
      imageCaptcha: '',
      imageCaptchaShow: false,
      imageCaptchaURL: '',
      timer: null,
      sendText: '发送验证码',
      disabled: false,
    };
  },
  deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    showImageCaptcha() {
      const { phone } = this;
      if (phone) {
        this.getImageCaptchaURL();
        this.imageCaptchaShow = true;
      } else {
        this.imageCaptchaShow = false;
      }
    },
    async getImageCaptchaURL() {
      const { phone } = this;
      if (phone) {
        const random = Math.random() * 10;
        this.imageCaptchaURL = `${apiURL}/patient-api/webapi/hospital-patient/get-image-captcha?phone=${phone}&captcha_type=Register&${random}`;
      }
    },
    setSendBtn() {
      let second = 90;
      this.disabled = true;
      this.timer = setInterval(() => {
        this.sendText = `重新发送(${second})`;
        second -= 1;
        if (second <= 0) {
          this.sendText = '发送验证码';
          this.disabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async handleSendSmsCode() {
      const { phone, imageCaptcha } = this;
      await this.$http.post('/patient-api/webapi/hospital-patient/send-sms-captcha', {
        phone,
        captcha_type: 'ResetPassword',
        image_captcha: imageCaptcha,
      });
      this.setSendBtn();
    },
    handleOnClickNext() {
      this.active = 1;
    },
    async handleOnSubmit() {
      const { password, repeatPassword } = this;
      if (password === repeatPassword) {
        const jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(rsaPublicKey);
        const { phone, captcha } = this;
        const newPassword = jsencrypt.encrypt(password);
        await this.$http.post('/patient-api/webapi/user/reset-password', {
          phone,
          captcha,
          new_password: newPassword,
        });
        this.active = 2;
      } else {
        this.$toast.fail('两次输入密码不一致');
      }
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 5rem;
}

.image-captcha {
  position: absolute;
  top: 50px;
  right: 16px;
  z-index: 1000;
}
</style>
